import React, { useEffect, createElement } from 'react';
export function TranslationProvider({
  children
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    // --- DETECCIÓN AUTOMÁTICA DE IDIOMA DEL DISPOSITIVO ---
    // Solo lo hacemos si el usuario no ha seleccionado un idioma manualmente en esta sesión
    if (!sessionStorage.getItem('languageSelected') && !document.cookie.includes('googtrans')) {
      const browserLang = navigator.language || (navigator as any).userLanguage;
      let targetLang = 'en'; // Por defecto inglés (Los Ángeles)
      if (browserLang.startsWith('es')) targetLang = 'es';else if (browserLang.startsWith('zh')) targetLang = 'zh-CN';else if (browserLang.startsWith('tl') || browserLang.startsWith('fil')) targetLang = 'tl';else if (browserLang.startsWith('hy')) targetLang = 'hy';
      // Forzamos la traducción al idioma detectado (incluyendo inglés, para traducir el texto base en español)
      document.cookie = `googtrans=/auto/${targetLang}; path=/`;
      document.cookie = `googtrans=/auto/${targetLang}; path=/; domain=${window.location.hostname}`;
      sessionStorage.setItem('languageSelected', 'true');
      // Recargamos suavemente para que Google Translate tome la cookie inicial
      window.location.reload();
    }
    // 1. Inicializar Google Translate
    if (!(window as any).googleTranslateElementInit) {
      ;
      (window as any).googleTranslateElementInit = () => {
        new (window as any).google.translate.TranslateElement({
          // Debe ser un idioma específico, 'auto' rompe el script
          pageLanguage: 'es',
          layout: (window as any).google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: false
        }, 'google_translate_element');
      };
      const script = document.createElement('script');
      script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
      script.async = true;
      document.body.appendChild(script);
    }
    // 2. Proteger los Headlines (h1, h2) para que NO se traduzcan
    // Usamos un MutationObserver para asegurarnos de que atrape los elementos incluso si React los renderiza después
    const observer = new MutationObserver(() => {
      const headlines = document.querySelectorAll('h1, h2');
      headlines.forEach(headline => {
        if (!headline.classList.contains('notranslate')) {
          headline.classList.add('notranslate');
          headline.setAttribute('translate', 'no');
        }
      });
    });
    // Observar todo el body por cambios en el DOM
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => {
      observer.disconnect();
    };
  }, []);
  return <>
      {/* Contenedor oculto requerido por Google Translate */}
      <div id="google_translate_element" style={{
      display: 'none'
    }} data-id="element-447"></div>
      {children}
    </>;
}